/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import AffiliateLogo from 'bundles/ent-website/components/AffiliateLogo';

import c4tLogo from 'images/ent-website/c4t-logo.svg';

import _t from 'i18n!nls/ent-website';

function C4TLogo() {
  const styles = {
    root: css`
      display: flex;
      flex-direction: row;
      align-items: center;
    `,
  };

  return (
    <div css={styles.root}>
      <img src={c4tLogo} width={240} alt={_t('Coursera for Teams')} />
      <AffiliateLogo />
    </div>
  );
}

export default C4TLogo;
